import { render } from "./ArchiveManagement.vue?vue&type=template&id=7fcc5a31&scoped=true"
import script from "./ArchiveManagement.vue?vue&type=script&lang=js"
export * from "./ArchiveManagement.vue?vue&type=script&lang=js"

import "./ArchiveManagement.vue?vue&type=style&index=0&id=7fcc5a31&lang=less&scoped=true"

import exportComponent from "D:\\cwzl\\cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fcc5a31"]])

export default __exports__